export const shopColumns = [
  'Código',
  'Nome',
  'Horário de funcionamento',
  'Geolocalização',
  '',
];
